document.addEventListener('DOMContentLoaded', () => {
	if (window.csFreeItemProduct) {
		const myCartWatcher = new CartWatcher
		myCartWatcher.init()

		function updateRemoveButtonStyles(hideProductIds = []) {
			let styleTag = document.getElementById('dynamic-remove-style');
			if (!styleTag) {
				styleTag = document.createElement('style');
				styleTag.id = 'dynamic-remove-style';
				document.head.prepend(styleTag);
			}

			if (hideProductIds.length) {
				const cssRules = hideProductIds.map(id =>
					`[product-id="${id}"] cart-remove-button { display: none !important; }`
				).join('\n');

				styleTag.textContent = cssRules;
			} else {
				styleTag.textContent = '';
			}
		}

		document.addEventListener("cart_changed", e => {
			console.log('cart_changed =============')
			fetch('/cart.json')
			.then(response => response.json())
			.then(cartData => {
				console.log(cartData.items)
				const cartItems = cartData.items
				const targetId = window.csFreeItemProduct
				const hasTargetProduct = cartItems.some(item => item.product_id === targetId)
				if (hasTargetProduct) {
					console.log('has item')
					const otherProductIds = cartItems
						.filter(item => item.product_id !== targetId)
						.map(item => item.id);
					updateRemoveButtonStyles(otherProductIds);
				} else {
					console.log('has no item')
					updateRemoveButtonStyles()
				}
			})
			.catch(error => console.error('Error fetching cart data:', error))
		})
	}
})